<div class="header">
    <h2>{{ title() }}</h2>
    <div class="header-actions">
        <p-button [label]="uploadLabel()" [icon]="uploadIcon()" data-test="dialog-select-media-upload" (onClick)="onUpload()" />
        <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="dialog-select-media-close" (click)="close()">
            <i class="pi pi-times"></i>
        </button>
    </div>
</div>

<div class="body">
    <app-dialog-search [placeholder]="searchPlaceholder" testId="dialog-select-media-search" (searchChange)="onSearch($event)" />

    <div class="list-container">
        @if (loading()) {
            <div class="list-loading"><i class="pi pi-spin pi-spinner"></i></div>
        }
        @if (items().length === 0 && !loading()) {
            <p class="empty">{{ 'dialogs.selectMedia.empty' | translate }}</p>
        } @else {
            <div class="list">
                @for (item of items(); track item.id) {
                    <button class="item" [attr.data-test]="'dialog-select-media-item-' + item.id" (click)="selectMedia(item)">
                        <app-media-preview [mediaId]="item.id" [type]="item.type" />
                        <span class="name">{{ item.name }}</span>
                        <app-type-chip [type]="item.type" translationPrefix="media.type" />
                        <span class="date">{{ item.createdAt | date: 'mediumDate' }}</span>
                    </button>
                }
            </div>
        }
    </div>
    <p-paginator [rows]="limit" [totalRecords]="total()" [first]="first()" (onPageChange)="onPageChange($event)" />
</div>
